import { render, staticRenderFns } from "./myNav.vue?vue&type=template&id=dfb1e4dc&scoped=true"
import script from "./myNav.vue?vue&type=script&lang=js"
export * from "./myNav.vue?vue&type=script&lang=js"
import style0 from "./myNav.vue?vue&type=style&index=0&id=dfb1e4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb1e4dc",
  null
  
)

export default component.exports